import React, { Suspense, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, LinearProgress } from "@material-ui/core";
import { renderRoutes } from "react-router-config";
import Footer from "./components/Footer";
import TopBar from "./components/TopBar";


const useStyles = makeStyles((theme) => ({
    root: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    loginBackground: {
        backgroundImage: 'url("/images/mountains.jpg")',
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
    },
    defaultBackground: {
        backgroundColor: theme.palette.background.default
    },
    topBar: {
        zIndex: 2,

        position: "relative"
    },
    content: {
        overflowY: "auto",
        flex: "1 1 auto",
    },
    container: {
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden"
    },
    footer: {
        zIndex: 4,
        position: "fixed",
        bottom: 0,
        padding: 5,
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        left: 0
    }
}));

const Dashboard = ({route}) => {
    const classes = useStyles();
    return (
        <div className={`${classes.root} ${window.location.pathname === "/login" ? classes.loginBackground : classes.defaultBackground}`}>
            <TopBar
                className={classes.topBar}
            />
            <div className={classes.container}>
                <main className={classes.content}>
                    <Suspense fallback={<LinearProgress/>}>
                        {renderRoutes(route.routes)}
                    </Suspense>
                </main>
            </div>
            <Footer
                className={classes.footer}/>
        </div>
    );
};

Dashboard.propTypes = {
    route: PropTypes.object
};

export default Dashboard;
